import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC, useState } from "react";

interface IAddNotesModal {
  open: boolean;
  onAddNote: (jobNumber: string, note: string) => void;
  onClose: () => void;
  jobNumber: string;
  note: string;
}

export const AddNotesModal: FC<IAddNotesModal> = ({
  open,
  onAddNote,
  onClose,
  jobNumber,
  note,
}) => {
  const [notes, setNotes] = useState(note);

  const changeHandler = (event: any) => {
    setNotes(event.value);
  };

  let textareaObj: any;

  function onCreate() {
    textareaObj.addAttributes({ rows: 1 });
    textareaObj.respectiveElement.style.height = "auto";
    textareaObj.respectiveElement.style.height = "300px";
  }

  const buttons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onAddNote(jobNumber, notes);
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={`Add Notes - Job Number ${jobNumber}`}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <TextBoxComponent
        ref={(scope: TextBoxComponent) => {
          textareaObj = scope;
        }}
        multiline={true}
        placeholder="Enter job notes"
        value={notes}
        created={onCreate}
        input={changeHandler}
      />
    </DialogComponent>
  );
};
